<template>
    <div class="row my-2">
        <div class="col-12" >
            <div class="card p-3" v-if="!rapd || collect == 2">
                <h2 class="mb-0" v-if="!rapd" >
                    {{__('messages.secure_your_reservation')}}
                </h2>
                <h5 v-if="!rapd" class="page-header-promo"><span class="font-icons icons-clock"></span> <strong>{{ __('messages.hurry_up') }}</strong> {{ __('messages.rate_can_change') }}
                </h5>
                <h5 v-if="collect == 2" class="page-header-promo"><span class="font-icons icons-check-circle"></span> <strong>{{ __('messages.no-need-pay-today') }}</strong> {{ __('messages.pay-accommodation') }}
                </h5>
            </div>
            <section v-if="rapd">
                <div class="d-flex g-8">
                    <h2><i class="icon-title icon-rapd align-middle"></i></h2>
                    <div>
                        <h2>{{__('messages.secure_your_reservationRAPD')}} </h2>
                        <p v-html="__('messages.secure_your_reservationRAPDDetail')"> </p>        
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    props: ['rapd','collect'],
    data() {
        return {
            data: {}
        };
    },
    async mounted() {
    },
    methods: {

    },
    components: {

    }
}
</script>
